import { APP_INITIALIZER, PLATFORM_ID } from '@angular/core';

import { UtilsService } from '../helpers/utils';

export function initPlatformId(platformId: Object): () => void {
  return () => {
    UtilsService.setPlatformId(platformId);
  };
}

export const provideInitPlatformId = () => {
  return {
    provide: APP_INITIALIZER,
    useFactory: initPlatformId,
    deps: [PLATFORM_ID],
    multi: true,
  };
};
